<template>
  <div class="select_dialog_embed">
    <div class="combined_sales_binding_embed_msg" :class="{'addModifyHandle': showType === 'add' || showType === 'modify'}">
      <div class="select_dialog_embed_box">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <div class="select_dialog_embed_box_content">
          <!--新增/编辑组合编码详情-->
          <div v-if="showType === 'add' || showType === 'modify'" class="select_dialog_embed_box_handle">
            <!--组合编码详情查询头部-->
            <div class="combined_sales_binding_detail_top">
              <div class="inb"><input type="text" v-model.trim="idOrName" placeholder="货号/品名" @keyup.enter="searchGoodsSkuInfo()"></div>
              <div class="inb"><input type="text" v-model.trim="color" placeholder="颜色" @keyup.enter="searchGoodsSkuInfo()"></div>
              <div class="inb"><input type="text" v-model.trim="size" placeholder="尺码" @keyup.enter="searchGoodsSkuInfo()"></div>
              <button class="btn_normal w116" @click="searchGoodsSkuInfo()">查询</button>
            </div>
            <!--第一个表格——货号对应的SKU可添加的信息-->
            <div class="combined_sales_binding_detail_center">
              <table class="table">
                <colgroup>
                  <col style="width: 100%">
                </colgroup>
                <thead>
                <tr>
                  <th>货号</th>
                  <th>颜色</th>
                  <th>尺码</th>
                  <th>商家编码</th>
                  <th>操作</th>
                </tr>
                </thead>
              </table>
              <table class="table">
                <colgroup>
                  <col style="width: 100%">
                </colgroup>
                <tbody>
                <tr v-for="(item, index) in addList" :key="index">
                  <td>{{item.GoodsId}}</td>
                  <td>{{item.ColorAlias}}</td>
                  <td>{{item.Size}}</td>
                  <td>{{item.BusinessCode}}</td>
                  <td><a title="添加" @click="addSKU(index)">添加</a></td>
                </tr>
                </tbody>
              </table>
            </div>

            <!--第二个表格——货号对应的SKU已点击添加的信息-->
            <div class="combined_sales_binding_detail_bottom">
              <table class="table">
                <colgroup>
                  <col style="width: 100%">
                </colgroup>
                <thead>
                <tr>
                  <th>货号</th>
                  <th>颜色</th>
                  <th>尺码</th>
                  <th>商家编码</th>
                  <th>类型</th>
                  <th>数量</th>
                  <th>操作</th>
                </tr>
                </thead>
              </table>
              <table class="table">
                <colgroup>
                  <col style="width: 100%">
                </colgroup>
                <tbody>
                <tr v-for="(item, index) in beAddedList" :key="index">
                  <td>{{item.GoodsId}}</td>
                  <td>{{item.ColorAlias}}</td>
                  <td>{{item.Size}}</td>
                  <td>{{item.BusinessCode}}</td>
                  <td>
                    <select class="w70 h20" v-model="item.SType" title="选择类型">
                      <option value="1">卖</option>
                      <option value="2">送</option>
                    </select>
                  </td>
                  <td>
                    <input type="text" v-model="item.Quantity" placeholder="数量">
                  </td>
                  <td><a title="删除" @click="delSKU(index)">删除</a></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--删除组合编码详情-->
          <div v-if="showType === 'del'" class="select_dialog_embed_box_handle">
            请确定是否删除组合销售？删除完成后平台输入的组合销售商家编码将无法关联！
          </div>
          <!--导入组合商家编码-->
          <div v-if="showType === 'import'" class="select_dialog_embed_box_handle">
            <span>选择上传的文件：</span>
            <input type="file" @change="tirggerFile($event)" accept=".xls,.xlsx">
          </div>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom">
          <button v-if="showType === 'add' || showType === 'modify'" class="btn_normal" @click="addModifySubmit()">确定</button>
          <button v-if="showType !== 'add' && showType !== 'modify'" class="btn_normal" @click="submitBtn()">确定</button>
          <button class="btn_cancel" @click="cancelBtn(false)">关闭</button>
        </div>
      </div>
    </div>

    <!--嵌入弹出框-->
    <div class="embed_dialog_msg" v-if="isSecondEmbed">
      <div class="combined_sales_binding_embed_msg">
        <div class="select_dialog_embed_box" :class="{'w461': showType === 'modify'}">
          <!--弹出框头部-->
          <div class="select_dialog_embed_box_top">
            <p>保存组合销售</p>
          </div>

          <!--弹出框信息-->
          <!--添加组合商家编码-->
          <div v-if="showType === 'add'" class="select_dialog_embed_box_content">
            <div class="text_center mt30 mb30">请输入组合销售的商家编码以便于在平台商家后台进行商家！</div>

            <div class="text_center mb20">组合商家编码：<div class="inb w276"><input type="text" v-model.trim="addCombinedSalesName" :title="addCombinedSalesName" maxlength="50"></div></div>
          </div>

          <!--编辑组合商家编码-->
          <div v-if="showType === 'modify'" class="select_dialog_embed_box_content">
            <div class="text_center mt30 mb30">请确定是否保存组合销售？</div>
          </div>

          <!--弹出框底部-->
          <div class="select_dialog_embed_box_bottom">
            <button class="btn_normal" @click="submitBtn()">确定</button>
            <button class="btn_cancel" @click="isSecondEmbed = false">取消</button>
          </div>
        </div>
      </div>
    </div>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script type="es6">
  import LoadingDialog from '../../public-component/loading-dialog';
  import MsgDialog from '../../public-component/msg-dialog';

  export default {
    name: 'combined-sales-binding-embed-msg',
    /**
     *  title：  头部名
     *  showType: add=新增组合编号  modify=编辑组合编号  del=删除组合编号
     *  combinedSalesMsg: 组合编号信息
     * */
    props: ['title', 'showType', 'combinedSalesMsg'],
    components: {LoadingDialog, MsgDialog},
    data() {
      return {
        idOrName: '', // 货号/品名
        color: '', // 颜色
        size: '', // 颜色
        addCombinedSalesName: '', // 添加的商家编码
        addList: [], // 添加的列表
        beAddedList: [], // 被添加的列表
        importFile: null, // 上传文件
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载页面类型
        isSecondEmbed: false, // 第二个嵌入弹出框
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        time: 3, // 倒计时时间
        timer: null // 计时器
      }
    },
    methods: {
      // 货品sku信息查询
      searchGoodsSkuInfo() {
         const params = {
             idOrName: this.idOrName,
             sizeName: this.size,
             colorAlias: this.color
         };
        this.$axios.post(this.Global.searchGoodsSkuInfo, params).then((res) => {
          console.log(res.data.resData);
          if (!res.data.errorMsg.length) {
            this.addList = res.data.resData;
          } else {
            this.addList = [];
          }
        });
      },

      // 根据id获取组合销售编辑信息
      getGroupGoodsDetailInfoById() {
        this.$axios.post(this.Global.getGroupGoodsDetailInfoById(this.combinedSalesMsg.Id), null).then((res) => {
          if (!res.data.errorMsg.length) {
            for (let i = 0; i < res.data.resData.length; i++) {
              this.beAddedList.push({
                'BusinessCode': res.data.resData[i].BusinessCode,
                'ColorAlias': res.data.resData[i].ColorAlias,
                'GoodsId': res.data.resData[i].GoodsId,
                'Size': res.data.resData[i].Size,
                'SkuId': res.data.resData[i].SkuId,
                'SType': res.data.resData[i].SType,
                'Quantity': res.data.resData[i].Quantity
              });
            }
          } else {
            this.beAddedList = [];
          }
        });
      },

      // 添加的内容
      addSKU(index) {
        this.beAddedList.push(this.addList[index]);
        this.$set(this.beAddedList[this.beAddedList.length - 1], 'SType', 1);
        this.$set(this.beAddedList[this.beAddedList.length - 1], 'Quantity', 1);
        this.addList.splice(index, 1);
      },

      // 删除SKU的内容
      delSKU(index) {
        this.addList.push(this.beAddedList[index]);
        this.beAddedList.splice(index, 1);
      },

      // 添加/编辑的确定按钮
      addModifySubmit() {
        let flag = true;
        console.log(this.beAddedList);
        for (let i = 0; i < this.beAddedList.length; i++) {
          if (!this.positiveInteger(this.beAddedList[i].Quantity)) {
            flag = false;
            this.txtMsg = '数量填写不正确，请输入大于0的正整数！';
            this.isSuc = false;
            this.isMsg = true;
          }
        }
        if (flag) {
          this.isSecondEmbed = true;
        }
      },

      // 添加/编辑的方法
      addModifyFun() {
        if (!this.addCombinedSalesName) {
          this.txtMsg = '组合商家编码不能为空！';
          this.isSuc = false;
          this.isMsg = true;
          return;
        }
        let GroupBusinessCode, id;
        if (this.showType === 'add') {
          GroupBusinessCode = this.addCombinedSalesName;
          id = '';
        } else {
          GroupBusinessCode = this.combinedSalesMsg.GroupBusinessCode;
          id = this.combinedSalesMsg.Id;
        }
        let params = [];
        for (let i = 0; i < this.beAddedList.length; i++) {
          params.push({
            SkuId: this.beAddedList[i].SkuId,
            GoodsId: this.beAddedList[i].GoodsId,
            SType: this.beAddedList[i].SType,
            Quantity: this.beAddedList[i].Quantity
          });
        }
        this.$axios.post(this.Global.saveAddOrUpdateGroupGoodsCodeInfo(GroupBusinessCode, id), params).then((res) => {
          if (!res.data.errorMsg.length) {
            this.cancelBtn(true);
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 根据id删除组合销售信息
      delGroupGoodsById() {
        this.$axios.post(this.Global.delGroupGoodsById(this.combinedSalesMsg.Id), null).then((res) => {
          if (!res.data.errorMsg.length) {
            this.cancelBtn(true);
          } else {
            this.txtMsg = res.data.errorMsg;
            this.isSuc = false;
            this.isMsg = true;
          }
        });
      },

      // 获取文件
      tirggerFile(e) {
        this.importFile = e.target.files;
      },

      // 组合编码导入【仅支持文件放在FormData方式上传】
      importGroupGoodsExcel() {
        if (!this.importFile) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择要导入的文件';
          return;
        }
        this.isLoading = true;
        this.loadingType = 'options';
        const formData = new FormData();
        formData.append('body', this.importFile[0]);
        this.$axios.post(this.Global.importGroupGoodsExcel, formData).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length && !res.data.resData) {
                // self.cancelBtn(true);
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '导入成功';
              } else if (res.data.resData) {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = '导入失败';
                setTimeout(function () {
                  window.open(res.data.resData);
                }, 500);
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 总的提交按钮
      submitBtn() {
        if (this.showType === 'add' || this.showType === 'modify') {
          this.addModifyFun();
        } else if (this.showType === 'del') {
          this.delGroupGoodsById();
        } else if (this.showType === 'import') {
          this.importGroupGoodsExcel();
        }

        // 计时器
        if (this.isMsg) {
          this.time = 3;
          const self = this;
          this.timer = setInterval(function () {
            self.time = --self.time;
            if (self.time < 1) {
              self.isMsg = false;
              clearInterval(self.timer);
            }
          }, 1000);
        }
      },

      // 取消按钮
      cancelBtn(type) {
        this.$emit('cancelbtn', {isShow: false, handleType: type});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
        if (this.isSuc) {
          this.cancelBtn(true);
        }
      },

      // 正整数的正则表达式
      positiveInteger(num) {
        const reg = /^[1-9]\d*$/;
        if (num && reg.test(num)) {
          return true;
        }
      }
    },
    created() {
      console.log(this.combinedSalesMsg);
      if (this.showType === 'modify') {
        this.addCombinedSalesName = this.combinedSalesMsg.GroupBusinessCode;
        this.getGroupGoodsDetailInfoById();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .select_dialog_embed {
    .select_dialog_embed_box {
      width: 640px;

      &.w461 {
        width: 461px;
      }
    }
    .addModifyHandle {
      width: 90%;
      min-width: 580px;
      max-height: 100%;

      .select_dialog_embed_box{
        width: 100%;

        .select_dialog_embed_box_handle {
          width: 100%;
          margin-top: 10px;

          .combined_sales_binding_detail_top {
            width: 98%;
            margin: 10px auto 5px;
          }

          .combined_sales_binding_detail_center, .combined_sales_binding_detail_bottom {
            width: 100%;

            table {
              width: 98%;
              margin: 0 auto;

              thead, tbody tr {
                display: table;
                width: 100%;
                table-layout: fixed;

                th, td {
                  padding: 10px 0;

                  input {
                    height: 20px;
                    line-height: 20px;
                  }
                }
              }

              tbody {
                display: block;
                width: 100%;
                height: 182px;
                overflow-y: auto;
              }
            }
          }

          .combined_sales_binding_detail_center {
            table {
              tbody {
                height: 172px;
              }
            }
          }
        }
      }
    }

    .embed_dialog_msg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0,0,0,.3);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/combined-sales-binding-embed-msg.vue